import { render, staticRenderFns } from "./ReadinessBadge.vue?vue&type=template&id=3c36674d&scoped=true"
import script from "./ReadinessBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadinessBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReadinessBadge.vue?vue&type=style&index=0&id=3c36674d&prod&lang=css"
import style1 from "./ReadinessBadge.vue?vue&type=style&index=1&id=3c36674d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36674d",
  null
  
)

export default component.exports